// @ts-check
import Link from '../Link/Link';

/**
 *
 * @param {object} props
 * @param {(any) => void} [props.onClick] The click handler.
 * @param {string | import('history').Location} [props.to] The internal link target to go to.
 * @param {boolean} [props.replace] Replace the state.
 * @param {string} [props.href] An external link to go to.
 * @param {keyof typeof import('./buttonVariants').default} [props.variant] The button's variant.
 * @param {boolean} [props.disabled] Disables the button.
 * @param {React.ReactNode} [props.children]
 * @param {string} [props.title]
 * @param {string} [props.className]
 * @param {string | React.FC} [props.as]
 * @param {React.ElementType} [props.fallback] An optional fallback element if no link or onClick handler is given
 * @param {'button' | 'submit'} [props.type] The button type for forms.
 * @returns {React.ReactElement}
 */
export default function Button({
  onClick,
  to,
  replace,
  href,
  children,
  variant = 'default',
  disabled,
  fallback = 'button',
  type = 'button',
  ...rest
}) {
  return (
    <Link
      onClick={onClick}
      to={to}
      replace={replace}
      href={href}
      variant="button" // `link.button` sets the general button styles.
      sx={{
        display: 'inline-block',
        variant: `button.${variant}`,
        ...(disabled && { opacity: 0.5 }),
        ':hover, :focus': {
          textDecoration: 'none',
        }, // FIXME Bootstrap style spill.
      }} // The variant sets the variant styles.
      fallback={fallback}
      // @ts-ignore
      type={type}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Link>
  );
}
